import request from '../http.js'


class Utils{
    uploadImgs(data) {
        return request.post('/utils/uploadimg', data)
    }
}



export default new Utils()